module.exports = __webpack_public_path__ + "img/20.8.TSS.8464d78e.png";